module.exports = __webpack_public_path__ + "img/Active-Managers@3x.592e1024.png";